// Mock data for Healthwrx website

export const clinicInfo = {
  name: "Healthwrx",
  tagline: "Wellbeing. Resilience. Xtra Life.",
  phone: "+91 9992604456",
  whatsapp: "+919992604456",
  email: "care@healthwrx.in",
  address: {
    line1: "5th Floor, S.B. Plaza",
    line2: "Rajendra Prasad Road, Last Gate",
    city: "Guwahati",
    pincode: "781006",
    state: "Assam"
  },
  hours: {
    weekdays: "9:00 AM - 7:00 PM",
    saturday: "9:00 AM - 7:00 PM",
    sunday: "Closed"
  },
  mapUrl: "https://maps.google.com/?q=S.B.+Plaza+Rajendra+Prasad+Road+Guwahati"
};

export const services = [
  {
    id: 1,
    title: "General Medicine",
    icon: "Stethoscope",
    description: "Comprehensive primary care for common health concerns and preventive care",
    details: [
      "Routine health check-ups",
      "Fever and infection management",
      "Chronic disease management",
      "Preventive health consultations"
    ]
  },
  {
    id: 2,
    title: "Specialist Consultations",
    icon: "UserRound",
    description: "Expert care from experienced specialists across multiple medical fields",
    details: [
      "Urology consultations",
      "Pulmonology services",
      "Nephrology care",
      "Endocrinology and diabetology"
    ]
  },
  {
    id: 3,
    title: "Diagnostics",
    icon: "Activity",
    description: "Advanced diagnostic services with accurate results and quick turnaround",
    details: [
      "Blood tests and pathology",
      "ECG and cardiac tests",
      "X-ray and imaging",
      "Health screening packages"
    ]
  },
  {
    id: 4,
    title: "Pharmacy",
    icon: "Pill",
    description: "In-house pharmacy with quality medicines and expert guidance",
    details: [
      "Prescription medications",
      "Over-the-counter medicines",
      "Health supplements",
      "Medicine home delivery"
    ]
  }
];

export const doctors = [
  {
    id: 1,
    name: "Dr. Nirupam Kalita",
    specialization: "General Medicine",
    experience: "10+ years",
    education: "MBBS, DNB (General Medicine)",
    image: "/doctors/dr_nirupam_kalita.jpg",
    availability: "Monday (6:00 PM - 7:30 PM), Thursday (6:00 PM - 7:00 PM)",
    bio: "Consultant General Physician specializing in comprehensive primary care and chronic disease management."
  },
  {
    id: 2,
    name: "Dr. Akash Adhikari",
    specialization: "Urology",
    experience: "12+ years",
    education: "MBBS, MS, DNB, MCh (Urology)",
    image: "/doctors/dr_akash_adhikari.jpg",
    availability: "Mon, Wed, Fri, Sat (4:00 PM - 6:00 PM)",
    bio: "Expert urologist with advanced training in minimally invasive urological procedures and kidney stone management."
  },
  {
    id: 3,
    name: "Dr. Kuntilraj Borgohain",
    specialization: "Pulmonology",
    experience: "8+ years",
    education: "MBBS, MD (Respiratory and Sleep Medicine)",
    image: "/doctors/dr_kuntilraj_borgohain.jpg",
    availability: "On-call availability",
    bio: "Specialist in respiratory diseases, sleep disorders, and critical care pulmonology."
  },
  {
    id: 4,
    name: "Dr. Atonu Saha",
    specialization: "Internal Medicine",
    experience: "10+ years",
    education: "MBBS, MD Medicine",
    image: "/doctors/dr_atonu_saha.jpg",
    availability: "On-call availability",
    bio: "Experienced internal medicine physician focusing on acute and chronic illness management."
  },
  {
    id: 5,
    name: "Dr. Himanish Goswami",
    specialization: "Nephrology",
    experience: "10+ years",
    education: "MBBS, MD (Internal Medicine), DrNB (Nephrology)",
    image: "/doctors/dr_himanish_goswami.jpg",
    availability: "Friday, Saturday (6:00 PM - 8:00 PM)",
    bio: "Specialist in kidney diseases, dialysis management, and hypertension with comprehensive nephrology care."
  },
  {
    id: 6,
    name: "Dr. Plabon Saikia",
    specialization: "Psychiatry",
    experience: "8+ years",
    education: "MBBS, MD Psychiatry",
    image: "/doctors/dr_plabon_saikia.jpg",
    availability: "Monday to Saturday (After 2:00 PM)",
    bio: "Mental health specialist providing comprehensive psychiatric care, counseling, and therapy services."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ramesh Baruah",
    location: "Guwahati",
    text: "The care I received at Healthwrx was exceptional. Dr. Sharma took time to understand my concerns and provided clear guidance.",
    rating: 5
  },
  {
    id: 2,
    name: "Anita Devi",
    location: "Guwahati",
    text: "Modern facilities, friendly staff, and expert doctors. The diagnostic services are quick and reliable.",
    rating: 5
  },
  {
    id: 3,
    name: "Kamal Das",
    location: "Guwahati",
    text: "I appreciate the convenience of having specialists, diagnostics, and pharmacy all under one roof. Highly recommended.",
    rating: 5
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Expert Medical Team",
    description: "Experienced doctors and specialists committed to your health",
    icon: "Award"
  },
  {
    id: 2,
    title: "Modern Facilities",
    description: "State-of-the-art equipment and comfortable environment",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Comprehensive Care",
    description: "All healthcare services available under one roof",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Patient-First Approach",
    description: "Personalized care focused on your wellbeing",
    icon: "Users"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What are your consultation hours?",
    answer: "We are open Monday to Saturday from 9:00 AM to 8:00 PM, and Sunday from 10:00 AM to 2:00 PM. Specific doctor availability may vary."
  },
  {
    id: 2,
    question: "Do you accept insurance?",
    answer: "Yes, we accept most major health insurance plans. Please contact us with your insurance details for confirmation."
  },
  {
    id: 3,
    question: "How do I book an appointment?",
    answer: "You can book an appointment through our website, call us at +91 9992604456, or WhatsApp us directly."
  },
  {
    id: 4,
    question: "Are diagnostic reports available online?",
    answer: "Yes, diagnostic reports are available digitally and can be accessed through our patient portal or via email."
  },
  {
    id: 5,
    question: "Do you provide home sample collection?",
    answer: "Yes, we offer home sample collection services for diagnostic tests. Please contact us to schedule."
  }
];
